/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {

  function getUrl(el) {
    return (
      el.getAttribute("href") ||
      el.dataset.url ||
      el.querySelector("a")?.href
    );
  }

  function handleNavigation(e) {

    // Only operate inside the search dropdown
    const searchArea = e.target.closest(
      ".search-bar__results, .search-bar__menu"
    );

    if (!searchArea) return;

    // Find the clickable search item
    const item = e.target.closest("a, .search-result, li, .search-item");

    if (!item) return;

    const url = getUrl(item);
    if (!url) return;

    // Override theme behaviour
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // Navigate after Safari finishes blur
    setTimeout(() => {
      window.location.href = url;
    }, 0);
  }

  // Safari-safe capture phase
  document.addEventListener("mousedown", handleNavigation, true);
  document.addEventListener("click", handleNavigation, true);

})();

